"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Stack_1 = __importDefault(require("@mui/material/Stack"));
// ContentBox is a box the width of the standard content area (1024px currently)
function ContentBox({ sx, children }) {
    return ((0, jsx_runtime_1.jsx)(Stack_1.default, Object.assign({ className: "ContentBox", sx: Object.assign({ 
            // todo: might want to have breakpoints for different widths depending on screen size.
            // minWidth: (theme: DecodableTheme) => theme.decodable.contentArea.minWidth,
            maxWidth: (theme) => { var _a, _b; return `min(100%, ${(_b = (_a = theme.decodable) === null || _a === void 0 ? void 0 : _a.contentArea) === null || _b === void 0 ? void 0 : _b.maxWidth})`; }, flexBasis: "900px", flexGrow: 1, flexShrink: 1 }, (sx || {})) }, { children: children })));
}
exports.default = ContentBox;
